import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const AccordionGroupRoot = styled.div`
	${() => {
		return css`
			display: flex;
			flex-direction: column;
			flex: 1 1 0%;
			min-height: 0;
		`;
	}}
`;
